import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuthState } from "../../hooks/use-auth-state";
import { publicAppUrl } from "./public-app-url";

export function MarketingCta() {
  const { user, loading } = useAuthState();

  if (loading) {
    return (
      <Button className="invisible" disabled tabIndex={-1} type="button">
        Get Started
      </Button>
    );
  }

  const href = user ? `${publicAppUrl()}/launch` : `${publicAppUrl()}/login`;
  const label = user ? "Open App" : "Get Started";
  const isAbsolute = href.startsWith("http://") || href.startsWith("https://");

  return (
    <Button asChild type="button">
      {isAbsolute ? <a href={href}>{label}</a> : <Link to={href}>{label}</Link>}
    </Button>
  );
}
